var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2EmailStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4585 48.3334C7.49183 48.3334 6.646 47.9709 5.921 47.2459C5.196 46.5209 4.8335 45.6751 4.8335 44.7084V13.2917C4.8335 12.3251 5.196 11.4792 5.921 10.7542C6.646 10.0292 7.49183 9.66675 8.4585 9.66675H49.5418C50.5085 9.66675 51.3543 10.0292 52.0793 10.7542C52.8043 11.4792 53.1668 12.3251 53.1668 13.2917V44.7084C53.1668 45.6751 52.8043 46.5209 52.0793 47.2459C51.3543 47.9709 50.5085 48.3334 49.5418 48.3334H8.4585ZM29.0002 29.7251C29.2016 29.7251 29.3727 29.6949 29.5137 29.6345C29.6547 29.574 29.8057 29.5036 29.9668 29.423L48.9377 17.0376C49.139 16.9167 49.2901 16.7556 49.3908 16.5542C49.4915 16.3529 49.5418 16.1313 49.5418 15.8897C49.5418 15.3661 49.3102 14.9532 48.847 14.6511C48.3838 14.349 47.9106 14.3591 47.4272 14.6813L29.0002 26.4626L10.6335 14.6813C10.1502 14.3591 9.66683 14.339 9.1835 14.6209C8.70016 14.9029 8.4585 15.3056 8.4585 15.8292C8.4585 16.0709 8.51891 16.3025 8.63975 16.524C8.76058 16.7456 8.90155 16.9167 9.06266 17.0376L28.0335 29.423C28.1946 29.5036 28.3456 29.574 28.4866 29.6345C28.6276 29.6949 28.7988 29.7251 29.0002 29.7251Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2EmailStandard);
export default __webpack_public_path__ + "static/media/v2-email-standard.337bee792ca84e8abe3d124ac8cd7a17.svg";
export { ForwardRef as ReactComponent };